export default __webpack_public_path__ + "static/media/LUCA-page-end.66787816.gif";